<div #layer class="tour-layer" popover="manual">
  @if (tours.step(); as step) {
    @if (spot(); as spot) {
      <div
        class="tour-spot"
        aria-hidden="true"
        [style.top.px]="spot.top - margin"
        [style.left.px]="spot.left - margin"
        [style.width.px]="spot.width + 2 * margin"
        [style.height.px]="spot.height + 2 * margin"
      ></div>
    }
    <aside
      #panel
      class="tour-panel"
      [attr.data-corner]="corner()"
      [attr.aria-label]="'Parcours de découverte : ' + tours.tour()?.title"
    >
      <div class="tour-head">
        <svg lucideSparkles class="tour-icon"></svg>
        <span class="tour-title">{{ tours.tour()?.domain }} · {{ tours.tour()?.title }}</span>
        <span class="tour-progress">{{ tours.stepIndex() + 1 }} / {{ tours.steps().length }}</span>
        <button
          mat-icon-button
          aria-label="Quitter le parcours"
          matTooltip="Quitter le parcours"
          (click)="tours.stop()"
        >
          <svg lucideX></svg>
        </button>
      </div>
      <div class="tour-step" aria-live="polite">
        <h2 class="step-title">{{ step.title }}</h2>
        <p class="step-text">{{ step.text }}</p>
        @if (!spot()) {
          <p class="step-absent">{{ step.whenAbsent }}</p>
        }
        @if (failure(); as failure) {
          <p class="step-failure" role="status">{{ failure }}</p>
        }
      </div>
      <div class="tour-actions">
        <button mat-button [disabled]="tours.isFirst()" (click)="tours.previous()">
          Précédent
        </button>
        <button mat-flat-button (click)="next()">
          {{ tours.isLast() ? 'Terminer' : 'Suivant' }}
        </button>
      </div>
    </aside>
  }
</div>
